import api from "./api";

export async function getSeedRecommendations() {
    const res = await api.get("/admin/seed-learning/recommendations");
    return res.data;
}

export async function runSeedLearning() {
    const res = await api.post("/admin/seed-learning/run");
    return res.data;
}

export async function getSeedLearningSignals(take = 25) {
    const res = await api.get("/admin/seed-learning/signals", {
        params: { take }
    });

    return res.data;
}

export async function getSeedLearningSignalSummary(take = 20) {
    const res = await api.get("/admin/seed-learning/signals/summary", {
        params: { take }
    });

    return res.data;
}

export async function runSeedQualityScan(payload) {
    const res = await api.post("/admin/seed-learning/quality-runs", payload);
    return res.data;
}

export async function getSeedQualityRuns(take = 20) {
    const res = await api.get("/admin/seed-learning/quality-runs", {
        params: { take }
    });

    return res.data;
}

export async function generateSeedDraftFromRecommendation(id) {
    const res = await api.post(`/admin/seed-learning/recommendations/${id}/generate-seed-draft`);
    return res.data;
}

export const materializeAllSeedImages = async () => {
    const { data } = await api.post("/admin/vertical-seeds/materialize-images");
    return data;
};

export const materializeSeedImages = async (seedId) => {
    const { data } = await api.post(`/admin/vertical-seeds/${seedId}/materialize-images`);
    return data;
};

export async function runSeedQualityScanForSeed(seedId) {
    const res = await api.post(`/admin/seed-learning/quality-runs/seed/${seedId}`);
    return res.data;
}

export async function runActiveSeedQualityBatch(maxCount = 20) {
    const res = await api.post("/admin/seed-learning/quality-runs/active-batch", {
        maxCount
    });

    return res.data;
}
export async function generateSeedTestSites(seedId, siteCount = 3) {
    const res = await api.post(`/admin/seed-learning/test-runs/seed/${seedId}`, null, {
        params: { siteCount }
    });

    return res.data;
}

export async function generateActiveSeedTestSites(maxSeeds = 5, siteCountPerSeed = 2) {
    const res = await api.post("/admin/seed-learning/test-runs/active-batch", {
        maxSeeds,
        siteCountPerSeed
    });

    return res.data;
}

export async function refreshSeedTestRun(runId) {
    const res = await api.post(`/admin/seed-learning/test-runs/${runId}/refresh`);
    return res.data;
}

export async function getSeedTestRuns(take = 10) {
    const res = await api.get("/admin/seed-learning/test-runs", {
        params: { take }
    });

    return res.data;
}

export async function getSeedTestRunProjects(runId) {
    const res = await api.get(`/admin/seed-learning/test-runs/${runId}/projects`);
    return res.data;
}

export async function runSeedSimulationForSeed(seedId) {
    const res = await api.post(`/admin/seed-learning/simulate/seed/${seedId}`);
    return res.data;
}

export async function getSeedComparison(industry, subIndustry) {
    const res = await api.get("/admin/seed-learning/seed-comparison", {
        params: {
            industry,
            subIndustry: subIndustry || ""
        }
    });

    return res.data;
}

export async function updateSeedTestProjectReview(testProjectId, payload) {
    const res = await api.post(
        `/admin/seed-learning/test-runs/projects/${testProjectId}/review`,
        {
            testStatus: payload.testStatus || "Pending",
            testSeverity: payload.testSeverity || "",
            testerNotes: payload.testerNotes || ""
        }
    );

    return res.data;
}

export async function getSeedTestRunBetaSummary(runId) {
    const res = await api.get(`/admin/seed-learning/test-runs/${runId}/beta-summary`);
    return res.data;
}